// Matches telematics-api's DASHBOARD_INDICATOR_FIELDS severity classification.
import { IndicatorSeverity } from "./types";

interface BadgeColors {
  color: string;
  bg: string;
  border: string;
}

// Real DTC events carry no severity classification — use one neutral style everywhere.
export const dtcBadge: BadgeColors = { color: "#374151", bg: "#f3f4f6", border: "#e5e7eb" };

export const INDICATOR_BADGES: Record<IndicatorSeverity, BadgeColors> = {
  critical: { color: "#b91c1c", bg: "#fef2f2", border: "#fecaca" },
  warning: { color: "#b45309", bg: "rgba(254,243,199,0.4)", border: "#fde68a" },
  info: { color: "#1d4ed8", bg: "#eff6ff", border: "#bfdbfe" },
  trailer: { color: "#6d28d9", bg: "#f5f3ff", border: "#ddd6fe" },
};

export const INDICATOR_SEVERITY_LABEL: Record<IndicatorSeverity, string> = {
  critical: "Critical",
  warning: "Warning",
  info: "Info",
  trailer: "Trailer",
};

// Rendering order: most urgent first.
export const INDICATOR_SEVERITY_ORDER: IndicatorSeverity[] = ["critical", "warning", "info", "trailer"];
